import { render, staticRenderFns } from "./CardDefaultList.vue?vue&type=template&id=7c274c8b&scoped=true&"
import script from "./CardDefaultList.vue?vue&type=script&lang=ts&"
export * from "./CardDefaultList.vue?vue&type=script&lang=ts&"
import style0 from "./CardDefaultList.vue?vue&type=style&index=0&id=7c274c8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c274c8b",
  null
  
)

export default component.exports